import React from 'react'
import { Explination } from '@enkla-gui'

export default function TextArea({ controls, name, options, label, error, rows = '10', disabled = false, cols = 'col', tip = false, placeholder = false }) {
  const { register } = controls
  const id = `field-${name}`
  const errorId = `${id}-error`
  var message
  const hasError = () => {
    var data = error.data
    if (data === undefined) return false
    name.split('.').forEach(value => {
      if (value in data) {
        data = data[value]
      } else {
        data = []
      }
    })
    if (data.length === 0) return false
    message = data[0]
    return true
  }
  const showError = error && hasError()
  return (
    <div class={`component_TextArea ${cols}`}>
      <div class={`form-group ${disabled ? 'form-group-disabled' : ''}`}>
        <label htmlFor={id}>
          {label}
          {options?.required && <span class='input-required'> * </span>}
          {tip && <Explination tip={tip} />}
        </label>
        <textarea
          rows={rows}
          {...register(name, options)}
          id={id}
          type='text'
          disabled={disabled}
          placeholder={placeholder}
          class='form-control'
          aria-invalid={showError ? 'true' : undefined}
          aria-describedby={showError ? errorId : undefined}
          aria-required={options?.required ? 'true' : undefined}
        />
        {showError && (
          <div class='form-inline-error' id={errorId}>
            <i class='fa fa-fw fa-exclamation-triangle' aria-hidden="true" />
            {message}
          </div>
        )}
      </div>
    </div>
  )
}
